<div class="app-container" role="region">
  <router-outlet></router-outlet>
</div>
